import { CheckBoxWithLabelWidget, CompactInlineAlertWidget, InlineAlertType, TextLinkKind, TextLinkWidget } from '@tableau/widgets';
import React = require('react');

import { Messages } from '~src/codegen/Localize';
import { HelpService } from '~src/commonInfra/services/HelpService';

import { editGroupDialogFieldStyles, externalUserCheckboxStyles, externalUserLabelStyles, externalUserTextLinkStyles, externalUserWarningStyles } from '../styles/EditGroupDialogStyles';
import { openEditExternalUserConfirmationDialog } from './EditEphemeralUserConfirmationDialog';
import { EditGroupDialogLabel } from './EditGroupDialogLabel';

export interface EditEphemeralUserFieldProps {
  readonly externalUserEnabled: boolean;
  readonly setExternalUserEnabled: (externalUserEnabled: boolean) => void;
}

export function EditEphemeralUserField(props: EditEphemeralUserFieldProps): JSX.Element  {
    return (
    <div style={editGroupDialogFieldStyles}>
        <EditGroupDialogLabel message={Messages.groupEphemeralUsers()} style={externalUserLabelStyles}/>
        <div>
            <CheckBoxWithLabelWidget
                checked={props.externalUserEnabled}
                handleChange={(checked: boolean) => handleCheck(checked, props)}
                testId={'edit-external-user-enabled-field'}
                label={Messages.groupEphemeralUsersCheckBoxLabel()}
                style={externalUserCheckboxStyles}/>
            <div style={externalUserTextLinkStyles}>
                <span>{Messages.groupEphemeralUsersDetailsLabel()}</span>
                &nbsp;
                <TextLinkWidget
                    testId={'external-user-learn-more'}
                    target={'_blank'}
                    href={HelpService.getHelpUrlByCategory('groups-ephemeral-users')}
                    kind={TextLinkKind.Standalone}>
                {Messages.learnMore()}
                </TextLinkWidget>
            </div>
            {props.externalUserEnabled &&
                <CompactInlineAlertWidget
                    children={Messages.groupEphemeralUserWarning()}
                    type={InlineAlertType.Warning}
                    testId='edit-external-user-enable-warning'
                    style={externalUserWarningStyles}/>
            }
        </div>
    </div>
    );
}

async function handleCheck(checked: boolean, props: EditEphemeralUserFieldProps) {
    if (!checked) {
        // if user is unchecking box, show confirmation dialog
        openEditExternalUserConfirmationDialog(props);
    } else {
        props.setExternalUserEnabled(checked);
    }
}

